import React from 'react';
import { Tree } from 'antd';
import { TreeProps } from 'antd/lib/tree';

export type { TreeProps };

const ProTree: React.FC<TreeProps> = React.forwardRef<any, TreeProps>(
  (props, ref) => {
    const { children, ...resProps } = props;

    return (
      <Tree ref={ref} {...resProps}>
        {children}
      </Tree>
    );
  },
);

export default ProTree;
